var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2330_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6305 12.3923L23.8613 1.37668C23.61 1.11965 23.263 0.972778 22.904 0.972778H4.05787C1.83223 0.972778 0.0253906 2.82096 0.0253906 5.10976V43.848C0.0253906 46.1246 1.83223 47.9728 4.05787 47.9728H30.9809C33.2066 47.9728 35.0254 46.1246 35.0254 43.8358V13.3592C35.0254 12.992 34.8698 12.6371 34.6305 12.3923ZM24.2562 5.67278L30.4305 11.9884H25.6083C24.8664 11.9884 24.2681 11.3764 24.2681 10.6176V5.67278H24.2562ZM30.9929 45.2189H4.06984C3.32795 45.2189 2.72966 44.6069 2.72966 43.848V5.10976C2.72966 4.3509 3.32795 3.73892 4.06984 3.73892H21.5639V10.6176C21.5639 12.8941 23.3707 14.7545 25.6083 14.7545H32.3331V43.8603C32.3331 44.6069 31.7348 45.2189 30.9929 45.2189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6083 20.4337H9.45443C8.71255 20.4337 8.10229 21.0457 8.10229 21.8045C8.10229 22.5634 8.70059 23.1876 9.45443 23.1876H25.6083C26.3502 23.1876 26.9484 22.5756 26.9484 21.8045C26.9484 21.0335 26.3502 20.4337 25.6083 20.4337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6083 25.9415H9.45443C8.71255 25.9415 8.10229 26.5535 8.10229 27.3124C8.10229 28.0712 8.70059 28.6832 9.45443 28.6832H25.6083C26.3502 28.6832 26.9484 28.0712 26.9484 27.3124C26.9484 26.5535 26.3502 25.9415 25.6083 25.9415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6083 31.4493H9.45443C8.71255 31.4493 8.10229 32.0613 8.10229 32.8202C8.10229 33.579 8.70059 34.191 9.45443 34.191H25.6083C26.3502 34.191 26.9484 33.579 26.9484 32.8202C26.9484 32.0613 26.3502 31.4493 25.6083 31.4493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2117 36.9572H9.44247C8.70059 36.9572 8.09033 37.5691 8.09033 38.328C8.09033 39.0868 8.68862 39.6988 9.44247 39.6988H20.2117C20.9536 39.6988 21.5519 39.0868 21.5519 38.328C21.5519 37.5691 20.9655 36.9572 20.2117 36.9572Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2330_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 47,
    fill: "white",
    transform: "translate(0.0253906 0.972778)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.03d9eed087e772e567f70453c3ccdf1f.svg";
export { ForwardRef as ReactComponent };